export function getErrorConfig(code, t) {
  switch (code) {
  //Acc not found
  case 20004:
    return {
      code: 20004,
      title: t("error.20004.title"),
      description: t("error.20004.description"),
      content: t("error.20004.content"),
      content1: t("error.20004.content1"),
      image: "/image/no_accounts.svg",
      actionLabel: t("error.20004.actionLabel"),
      phoneNubmer: t("error.20004.actionType.phone.value"),
      mailId: t("error.20004.actionType.mail.value"),
    };
  case 20005:
    return {
      code: 20005,
      title: t("error.20005.title"),
      description: t("error.20005.description"),
      content: t("error.20005.content"),
      content1: t("error.20005.content1"),
      image: "/image/no_accounts.svg",
      actionLabel: t("error.20005.actionLabel"),
      phoneNubmer: t("error.20005.actionType.phone.value"),
      mailId: t("error.20005.actionType.mail.value"),
    };
  case 20006:
    return {
      code: 20006,
      title: t("error.20006.title"),
      description: t("error.20006.description"),
      content: t("error.20006.content"),
      content1: t("error.20006.content1"),
      image: "/image/no_accounts.svg",
      actionLabel: t("error.20006.actionLabel"),
      phoneNubmer: t("error.20006.actionType.phone.value"),
      mailId: t("error.20006.actionType.mail.value"),
    };
    //system error
  case 40001:
    return {
      code: 40001,
      title: t("error.40001.title"),
      description: t("error.40001.description"),
      content: t("error.40001.content"),
      image: "/image/computer_cancel.svg",
      actionLabel: t("error.40001.actionLabel"),
    };
    //data loading error
  case 30001:
    return {
      code: 30001,
      title: t("error.30001.title"),
      description: t("error.30001.description"),
      content: t("error.30001.content"),
      image: "/image/data_loading.svg",
      actionLabel: t("error.30001.actionLabel"),
      phoneNubmer: t("error.30001.actionType.phone.value"),
      mailId: t("error.30001.actionType.mail.value"),
    };

  default:
    return {
      title: t("error.40001.title"),
      description: t("error.40001.description"),
      content: t("error.40001.content"),
      image: "/image/computer_cancel.svg",
      actionLabel: t("error.40001.actionLabel"),
    };
  }
}
